import { render, staticRenderFns } from "./Band.vue?vue&type=template&id=bfe8724e&scoped=true"
import script from "./Band.vue?vue&type=script&lang=js"
export * from "./Band.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe8724e",
  null
  
)

export default component.exports